export default "__VITE_ASSET__C52ZDuu8__"